<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item :label="$locale('global.username')" prop="cinemaAccountUserName" :rules="formRules.cinemaAccountUserName">
      <el-input :placeholder="$locale('form.plsEnterYourUsername')" v-model="detailObj.cinemaAccountUserName" :disabled="!editable" maxlength="50"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('global.password')" prop="cinemaAccountPassword" :rules="formRules.cinemaAccountPassword">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj.cinemaAccountPassword"
        :disabled="!editable"
        show-password
        autocomplete="new-passwor"
        auto-complete="new-password"
        maxlength="20"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.brand.account.passconfirm')" prop="passwordAgain" :rules="formRules.passwordAgain">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj.passwordAgain"
        :disabled="!editable"
        show-password
        autocomplete="new-passwor"
        auto-complete="new-password"
        maxlength="20"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$locale('global.email')">
      <el-input :placeholder="$locale('setting.brand.p.email')" v-model="detailObj.cinemaAccountEmail" :disabled="!editable" maxlength="100"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "cinemaAccountSetting",
  props: {
    detailObj: Object,
  },
  data() {
    return {
      editable: true,
      action: "create",
      passwordAgain: "",
      formRules: {
        cinemaAccountUserName: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        cinemaAccountPassword: [ {
          required: true,
          message: this.$locale("form.plsEnterYourPassword"),
        } ],
        passwordAgain: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
      },
    };
  },
  methods: {},
};
</script>
